import React, { useState, useEffect } from 'react';
import { getDevice } from '../js/framework7-custom.js';
import {
  f7,
  f7ready,
  App,
  Panel,
  View,
  Popup,
  Page,
  Navbar,
  NavRight,
  Link,
  Block,
  LoginScreen,
  LoginScreenTitle,
  List,
  ListItem,
  ListInput,
  ListButton,
  BlockFooter,
  Button,
  AccordionContent,
  Input,
} from 'framework7-react';
import cordovaApp from '../js/cordova-app';

import routes from '../js/routes';
import store from '../js/store';
import '../css/grid.css';

import haccpUtils from '../js/haccp-utils.js';

import Dom7 from 'dom7';
import ReactDOM from 'react-dom';

document.addEventListener("deviceready", onDeviceReady, false);
function onDeviceReady() {
    window.open = cordova.InAppBrowser.open;
}

const MyApp = () => {
  var $$ = Dom7
  const storage = haccpUtils.getStorage();

  var 年月日 = haccpUtils.getToday("yyyy年m月d日");

  // Login screen demo data
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const device = getDevice();
  // Framework7 Parameters
  const f7params = {
    name: '簡単HACCP', // App name
    theme: 'auto', // Automatic theme detection


    id: 'com.mylabo-net.haccp-app', // App bundle ID
    // App store
    store: store,
    // App routes
    routes: routes,
    // Register service worker
    serviceWorker: {
      path: './service-worker.js',
    },

    // Input settings
    input: {
      scrollIntoViewOnFocus: device.cordova && !device.electron,
      scrollIntoViewCentered: device.cordova && !device.electron,
    },
    // Cordova Statusbar settings
    statusbar: {
      iosOverlaysWebView: true,
      androidOverlaysWebView: false,
    },
    className: haccpUtils.updatePermissionDisplay().join(" ")
  };


  const loadConstants = (data) => {
    console.log(data)
    // 認証確認
    if (data.token && data.token != "") {
      // 認証成功時
      storage.setItem("#USER#token", data.token)
      storage.setItem("#USER#user", data.user)
      storage.setItem("#USER#account", data.account)

      // options
      storage.setItem("#USER#itemOptions", data.itemOptions)
      storage.setItem("#USER#timeElementOptions", data.timeElementOptions)
      storage.setItem("#USER#menuOptions", data.menuOptions)
      storage.setItem("#USER#shopOptions", data.shopOptions)
      storage.setItem("#USER#categoryOptions", data.categoryOptions)
    }

    storage.setItem("#USER#defaultGeneralTempleteValid", data.defaultGeneralTempleteValid)
    storage.setItem("#USER#defaultImportantTemplateValid", data.defaultImportantTemplateValid)

    haccpUtils.updatePermissionDisplay()
  }
  const alertLoginData = (text, title) => {
    haccpUtils.request(f7, {
      url: '/user/login',
      method: "POST",
      contentType: "application/json",
      crossDomain: true,
      data: { "username": username, "password": password },
      dataType: "json",
      success: function (body, status, xhr) {
        console.log("success");
        console.log(body);
        loadConstants(body["data"])
      },
      error: function (xhr, status, message) {
        console.log("error");
        loadConstants({ token: "" })
      },
      complete: function (xhr, status) {
        console.log(xhr, status);
        if (200 <= status && status < 300) {
          var message = "ログインしました。";
          // 初期画面
          f7.panel.close(".panel-right"); // 右パネルを閉じる
          f7.panel.close(".panel-left"); // 左パネルを閉じる

          f7.views.get(".view-main").router.navigate({ name: 'TodayGeneralCtrl' }); // 中央に表示

          // const modifyGeneralCtrlDate = haccpUtils.modifyGeneralCtrlDate(-1)
          // modifyGeneralCtrlDate()

          f7.loginScreen.close();
        } else {
          const closeLoginPanel = () => {
            f7.panel.close(".panel-right"); // 右パネルを閉じる
            f7.panel.close(".panel-left"); // 左パネルを閉じる
            f7.views.get(".view-main").router.navigate({ name: 'TopPage' }); // 中央に表示
            // f7.loginScreen.close();
          }

          f7.dialog.create({
            text: text,
            title: title,
            buttons: [
              {
                text: 'はい',
                onClick: function () {
                  const resetUser = f7.form.convertToData("#haccp-popup form")
                  haccpUtils.sendValidCode(f7, { "username": username });
                },
              },
              {
                text: 'いいえ',
                onClick: closeLoginPanel,
              },
            ],
          }).open();

          // f7.dialog.confirm(text,title,
          //   function () {
          //     const resetUser = f7.form.convertToData("#haccp-popup form")
          //     haccpUtils.sendValidCode(f7, {"username": username});
          //   },
          //   closeLoginPanel,
          // );
        }
      },
      statusCode: {
        401: function (xhr) {
          console.log(xhr)
        }
      },
    });
  }

  const openCreateUserDialog = () => {
    console.log("[openCreateUserDialog]")

    var popup = $$("#haccp-popup")

    const createUser = () => {
      console.log("createuser")

      const storedUser = f7.form.convertToData("#haccp-popup form")

      haccpUtils.request(f7, {
        url: '/user',
        method: "POST",
        contentType: "application/json",
        crossDomain: true,
        data: storedUser,
        dataType: "json",
        success: function (body, status, xhr) {
          console.log("success");
          console.log(body);
          haccpUtils.openResetPasswordDialog(f7, body.data.validUser.email, "登録")

          // var message = "ユーザを登録しました。";
          // f7.dialog.alert(message, () => {
          //   f7.popup.close("#haccp-popup");
          // });

        },
        error: function (xhr, status, message) {
          console.log("error");
          var message = "ユーザ作成に失敗しました。";
          f7.dialog.alert(message, () => {
            f7.popup.close("#haccp-popup");
          });
        },
        statusCode: {
          401: function (xhr) {
            console.log(xhr)
          }
        },
      });
    }

    var view = (
      <View>
        <Page>
          <Navbar title="ユーザ作成">
            <NavRight>
              <Link popupClose iconF7="xmark"></Link>
            </NavRight>
          </Navbar>
          <form></form>
        </Page>
      </View>
    )

    var popup = $$("#haccp-popup")
    ReactDOM.render(view, popup[0])


    var form = $$("#haccp-popup form")
    const list = (
      <List>
        <ListInput
          // outline
          type="text"
          name="last_name"
          placeholder="姓"
          maxlength="100"
          required
          validateOnBlur
        // onInput={(e) => setLastName(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="text"
          name="first_name"
          placeholder="名"
          maxlength="100"
          required
          validateOnBlur
        // onInput={(e) => setFirstName(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="text"
          name="last_name_kana"
          placeholder="姓（カナ）"
          maxlength="100"
          required
          validateOnBlur
        // onInput={(e) => setLastNameKana(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="text"
          name="first_name_kana"
          placeholder="名（カナ）"
          maxlength="100"
          required
          validateOnBlur
        // onInput={(e) => setFirstNameKana(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="text"
          name="shop_name"
          placeholder="店舗名"
          maxlength="200"
          required
          validateOnBlur
        // onInput={(e) => setShopName(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="email"
          name="email"
          placeholder="メールアドレス"
          maxlength="255"
          required
          validateOnBlur
        // onInput={(e) => setEmailAddress(e.target.value)}
        ></ListInput>
        <ListInput
          // outline
          type="text"
          name="zip"
          placeholder="郵便番号 ex.1060032(- なし)"
          validate
          pattern="[0-9]*"
          data-error-message="入力できるのは数値のみです"
          maxlength="7"
          required
          validateOnBlur
        ></ListInput>
        <ListInput
          // outline
          type="textarea"
          name="addr"
          placeholder="住所"
          maxlength="255"
          required
          validateOnBlur
        ></ListInput>
        <ListInput
          // outline
          type="tel"
          name="tel"
          placeholder="電話番号"
          maxlength="20"
          required
          validateOnBlur
        ></ListInput>


        <ListButton
          className="terms-btn"
          title="利用規約"
          onClick={(e) => {
            f7.dialog.create({
              text: "<p>利用規約<br>この利用規約（以下，「本規約」といいます。）は，株式会社スズカ未来（以下，「当社」といいます。）がこのアプリケーション上で提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。<br>登録ユーザーの皆さま（以下，「ユーザー」といいます。）には，本規約に従って，本サービスをご利用いただきます。<br><br>第１条（保証の否認及び免責）<br>１　ユーザーは、本件サービスに入力した情報の全てについて、事故の責任において保管及び管理するものとし、当社は、理由の如何を問わずユーザーのデータの消失ないし破損等について一切の責任を負いません。<br>２　当社は、当社による本サービスの提供の中断、停止、終了、利用不能または変更、登録ユーザーが本サービスに送信したメッセージまたは情報の削除または消失、登録ユーザーの登録の抹消、本サービスの利用による登録データの消失または機器の故障もしくは損傷、その他本サービスに関してユーザーが被った損害につき、賠償する責任を一切負わないものとします。<br>３　当社は、本サービスがユーザーの特定の目的に適合すること、期待する機能・商品的価値・正確性・有用性を有すること、及び不具合が生じないことについて、何ら保証するものではありません。<br>４　本条に定める当社の責任の制限に関する規定は、当社の故意又は重過失の場合を除きます。なお、当社が損害賠償義務を負う場合であっても、当社は、ユーザーに生じた損害につき直接且つ現実に被った損害を上限として損害賠償義務を負うものとし、間接損害、特別損害、将来の損害及び逸失利益にかかる損害については賠償する責任を負わないものとします。<br><br>第２条（本サービスの提供の停止等）<br>１　当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。<br>　１　本サービスにかかるコンピュータシステムの保守点検または更新を行う場合<br>　２　地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合<br>　３　コンピュータまたは通信回線等が事故により停止した場合<br>　４　その他，当社が本サービスの提供が困難と判断した場合<br>２　当社は，本サービスの提供の停止または中断により，ユーザーまたは第三者が被ったいかなる不利益または損害についても，一切の責任を負わないものとします。<br>３　当社は、当社の判断により、本サービスの内容を変更し、または提供を終了することができます。</p>",
              title: "",
              buttons: [
                {
                  text: '閉じる',
                },
              ],
            }).open();
          }}
          popupOpen="#haccp-popup"
        />
        <ListItem
          className="terms-checkbox terms-check"
          type="text"
          name="terms_checkbox"
        >
          <div class="checkboxMessage">
            <input name="terms_checkbox_msg" id="termsCheckbox" type="checkbox"/>利用規約に同意する
          </div>
          <div class="checkboxErrorMessage item-input-error-message">
            <p id='termsCheckboxMessage'></p>
          </div>
        </ListItem>



        <ListButton title="登録" onClick={(e) => {


          if($$("#termsCheckbox")[0].checked){

            if (!haccpUtils.validateForm($$(e.target).closest("form"), e.target)) {
              return false;
            }
            // テストコード
            // $$("#termsCheckboxMessage")[0].innerText='チェック入ってるよーー'
            f7.dialog.create({
              text: "確認コードをメールでお送りします。次の画面で入力してください。",
              title: "",
              buttons: [
                {
                  text: 'ＯＫ',
                  onClick: function () {
                    createUser();
                  },
                },
                {
                  text: 'キャンセル',
                },
              ],
            }).open();
      

          }else{
            $$("#termsCheckboxMessage")[0].innerText='利用規約に同意いただきチェックボックスにチェックを入れてください。'
            $$("#termsCheckbox").on("click", ()=>$$("#termsCheckboxMessage")[0].innerText='')
            // 下の書き方も同じ
            // $$("#termsCheckbox").onClick(()=>$$("#termsCheckboxMessage")[0].innerText='')
            if (!haccpUtils.validateForm($$(e.target).closest("form"), e.target)) {
              return false;
            }
          }



          // f7.dialog.confirm("確認コードをメールでお送りします。次の画面で入力してください。","",
          //   function () {
          //     createUser();
          //   },
          // )




        }} />

        {/* <ListButton title="登録" onClick={(e) => {
          if (!haccpUtils.validateForm($$(e.target).closest("form"), e.target)) {
            return false;
          }
          createUser();
        }} /> */}
        <BlockFooter>
        </BlockFooter>
      </List>
    )
    ReactDOM.render(list, form[0])
    console.log("[createUser:]")


  }

  f7ready(() => {
    // Init cordova APIs (see cordova-app.js)
    if (f7.device.cordova) {
      cordovaApp.init(f7);
    }

    // Call F7 APIs here
  });

  const logout = () => {
    console.log("logout")
    storage.clearItems(); // セッション削除
    f7.panel.close(".panel-right"); // 右パネルを閉じる
    f7.panel.close(".panel-left"); // 左パネルを閉じる
    f7.views.get(".view-main").router.navigate({ name: 'TopPage' }); // 中央に表示
  }
  var initPage = haccpUtils.isLogined() ? "/Today-General-Ctrl/" : "/top-page/"
  return (
    <App {...f7params} >

      {/* Left panel with cover effect when hidden */}
      <Panel left cover themeDark visibleBreakpoint={960}>
        <View>
          <Page className="side-menu">
            {/* <Navbar title="メニュー">
              </Navbar> */}
            <List>
              <ListItem className="top-title"><div class="title-size">　</div></ListItem>
              {/* <ListItem link="/" view=".view-main" panelClose title="ホーム"/> */}
              <ListItem link="/information/" view=".view-main" panelClose className="notice" title="お知らせ" />
            </List>
            {/* 毎日の記録 */}
            <div class="haccp-role-invisible haccp-role-admin haccp-role-user">
              <List>
                <ListItem className="record-title"><div class="title-size">毎日の記録</div></ListItem>
                <ListItem
                  className="general"
                  panelClose
                  title="一般衛生管理実施記録"
                  onClick={() => {
                    haccpUtils.modifyGeneralCtrlDate(-1)
                    f7.panel.close(".panel-left"); // 左パネルを閉じる
                    f7.views.get(".view-main").router.navigate({ name: 'TodayGeneralCtrl' });
                  }
                  }
                  link="#"
                />
                <ListItem
                  className="important"
                  panelClose
                  title="重要衛生管理実施記録"
                  onClick={() => {
                    haccpUtils.modifyImportantCtrlDate(-1)
                    f7.panel.close(".panel-left"); // 左パネルを閉じる
                    f7.views.get(".view-main").router.navigate({ name: 'TodayImportantCtrl' });
                  }
                  }
                  link="#"
                />
                <ListItem className="general" link="/General-Hygienic-Ctrl/" view=".view-main" panelClose title="一般衛生管理実施記録一覧" />
                <ListItem className="important" link="/Important-Hygienic-Ctrl/" view=".view-main" panelClose title="重要衛生管理実施記録一覧" />
              </List>
            </div>
            {/* 計画 */}
            <div class="haccp-role-invisible haccp-role-admin haccp-role-user">
              <List>
                <ListItem className="plan-title"><div class="title-size">計画</div></ListItem>
                <ListItem className="general" link="/General-Hygienic-Ctrl-Plan/" view=".view-main" panelClose title="一般衛生管理計画" />
                <ListItem className="important" link="/Important-Hygienic-Ctrl-Plan/" view=".view-main" panelClose title="重要衛生管理計画" />
              </List>

            </div>
            {/* 管理 */}
            <div class="haccp-role-invisible haccp-role-admin">
              <List>
                <ListItem accordionItem title="管理" className="manegement-title haccp-role-invisible haccp-role-system haccp-role-admin">
                  <AccordionContent>
                    <List className="haccp-role-invisible haccp-role-system">
                      <ListItem className="template-title"><div class="title-size">計画テンプレート</div></ListItem>
                      <ListItem className="general" link="/Default-General-Template/" view=".view-main" panelClose title="ﾃﾞﾌｫﾙﾄ一般ﾃﾝﾌﾟﾚｰﾄ" />
                      <ListItem className="general" link="/General-Ctrl-Plan-Template-List/" view=".view-main" panelClose title="一般衛生管理計画ﾃﾝﾌﾟﾚｰﾄ" />
                      <ListItem className="important" link="/Default-Important-Template/" view=".view-main" panelClose title="ﾃﾞﾌｫﾙﾄ重要ﾃﾝﾌﾟﾚｰﾄ" />
                      <ListItem className="important" link="/Important-Ctrl-Plan-Template-List/" view=".view-main" panelClose title="重要衛生管理計画ﾃﾝﾌﾟﾚｰﾄ" />
                    </List>
                    <List className="haccp-role-invisible haccp-role-system">
                      <ListItem className="mst-title"><div class="title-size">システム管理</div></ListItem>
                      <ListItem className="mst" link="/Item-Mst/" view=".view-main" panelClose title="項目マスタ" />
                      <ListItem className="mst" link="/Time-Element-Mst/" view=".view-main" panelClose title="時間要素マスタ" />
                      <ListItem className="mst" link="/Category-Mst/" view=".view-main" panelClose title="分類マスタ" />
                      <ListItem className="mst" link="/Menu-Mst/" view=".view-main" panelClose title="メニューマスタ" />
                      <ListItem className="mst" link="/Department-Mst/" view=".view-main" panelClose title="部門マスタ" />
                      <ListItem className="mst" link="/Shop-Mst-Maintenance/" view=".view-main" panelClose title="店舗マスタメンテ" />
                    </List>
                    <List className="haccp-role-invisible haccp-role-admin">
                      <ListItem className="mst-title"><div class="title-size">分析</div></ListItem>
                      <ListItem className="mst" link="/User-Count-History/" view=".view-main" panelClose title="登録ユーザ数" />
                      <ListItem className="mst" link="/Record-History/" view=".view-main" panelClose title="記録履歴" />
                    </List>
                    <List className="haccp-role-invisible haccp-role-admin">
                      <ListItem className="mst-title"><div class="title-size">マスタ管理</div></ListItem>
                      <ListItem className="mst" link="/top-page-information/" view=".view-main" panelClose title="トップページ情報" />
                      <ListItem className="mst" link="/csv-download/" view=".view-main" panelClose title="CSVダウンロード" />
                      <ListItem className="mst" link="/User-Mst-Maintenance/" view=".view-main" panelClose title="ユーザマスタメンテ" />
                      <ListItem className="mst" link="/Shop-Mst/" view=".view-main" panelClose title="店舗マスタ" />
                      <ListItem className="mst" link="/User-Mst/" view=".view-main" panelClose title="ユーザマスタ" />
                      <ListItem className="mst" link="/Account-Mst/" view=".view-main" panelClose title="アカウントマスタ" />
                    </List>

                  </AccordionContent>
                </ListItem>
              </List>
            </div>
            <List>
              <ListItem className="profile-title" accordionItem title="マイページ">
                <AccordionContent>
                  <Button large raised className="profile-button haccp-role-invisible haccp-role-guest" popupOpen="#my-login-screen">ログイン</Button>
                  <Button large raised className="profile-button haccp-role-invisible haccp-role-pre-regist" onClick={() => haccpUtils.sendValidCode(f7)}>初回メール認証</Button>
                  <Button large raised className="profile-button haccp-role-invisible haccp-role-admin haccp-role-user" href="/my-page/" view=".view-main" panelClose>会員情報</Button>
                  <Button large raised className="profile-button haccp-role-invisible haccp-role-admin haccp-role-user" onClick={() => haccpUtils.sendValidCode(f7)}>パスワード変更</Button>
                  <Button large raised className="profile-button haccp-role-invisible haccp-role-admin haccp-role-user haccp-role-pre-regist" onClick={logout}>ログアウト</Button>
                  {/* <Button large raised className="profile-button haccp-role-invisible haccp-role-guest" onClick={() => {window.location.reload(true)}}>アプリケーション更新</Button> */}
                </AccordionContent>
              </ListItem>
              <ListItem className="terms-service-title" link="/terms-service/" view=".view-main" panelClose title="利用規約" />
            </List>

          </Page>
        </View>
      </Panel>


      {/* Right panel with reveal effect*/}
      <Panel right reveal themeDark>
        <View>
          <Page>
            <List>
              <ListItem accordionItem title="マイページ">
                <AccordionContent>


                </AccordionContent>
              </ListItem>
            </List>
          </Page>
        </View>
      </Panel>


      {/* Your main view, should have "view-main" class */}
      <View main className="safe-areas" url={initPage} />

      {/* Popup */}
      {/* <Popup id="my-popup">
        <View>
          <Page>
            <Navbar title="Popup">
              <NavRight>
                <Link popupClose iconF7="xmark"></Link>
              </NavRight>
            </Navbar>
            <Block>
              <p>Popup content goes here.</p>
            </Block>
          </Page>
        </View>
      </Popup>
      <Popup id="my-popup3">
        <View>
          <Page>
            <Navbar title="一般衛生管理計画を削除する">
              <NavRight>
                <Link popupClose iconF7="xmark"></Link>
              </NavRight>
            </Navbar>
            <Block>
              <p>一般衛生管理計画”を削除します</p>
                <Row>
                  <Col>
                    <Button fill>削除</Button>
                  </Col>
                </Row>
            </Block>
          </Page>
        </View>
      </Popup> */}

      <LoginScreen id="my-login-screen">
        <View>
          <Page loginScreen>
            <LoginScreenTitle>ログイン</LoginScreenTitle>
            <form>
              <List>
                <ListInput
                  type="email"
                  name="username"
                  placeholder="メールアドレス"
                  value={username}
                  onInput={(e) => setUsername(e.target.value)}
                  required
                  validateOnBlur
                ></ListInput>
                <ListItem>
                  <Input
                    type="password"
                    name="password"
                    placeholder="パスワード"
                    value={password}
                    style={{ width: "100%" }}
                    onInput={(e) => setPassword(e.target.value)}
                    required
                    validateOnBlur
                  />
                  <Link iconF7="eye"
                    name="eye"
                    style={{
                      display: "inherit",
                      padding: "0px 10px",
                      height: "100%",
                      // backgroundColor: "rgb(232, 240, 254)"
                      position: "absolute",
                      right: "25px"
                    }}
                    onClick={(event) => {
                      const el_password = $$(event.target).closest("form").find('[name="password"]')
                      const el_eyes = $$(event.target).closest("form").find('a.link.icon-only')
                      console.log("el_eyes", el_eyes[0], el_eyes[1])

                      if (el_password.prop("type") != "password") {
                        el_password.prop("type", "password")
                      } else {
                        el_password.prop("type", "text")
                      }
                      if (el_eyes[0].style.display == "none") {
                        el_eyes[0].style.display = "inherit"
                        el_eyes[1].style.display = "none"
                      } else {
                        el_eyes[0].style.display = "none"
                        el_eyes[1].style.display = "inherit"
                      }
                      return false;
                    }} />
                  <Link iconF7="eye_slash"
                    style={{
                      display: "none",
                      padding: "0px 10px",
                      height: "100%",
                      // backgroundColor: "rgb(232, 240, 254)"
                      position: "absolute",
                      right: "25px"
                    }}
                    onClick={(event) => {
                      const el_password = $$(event.target).closest("form").find('[name="password"]')
                      const el_eyes = $$(event.target).closest("form").find('a.link.icon-only')
                      console.log("el_eyes", el_eyes[0], el_eyes[1])

                      if (el_password.prop("type") != "password") {
                        el_password.prop("type", "password")
                      } else {
                        el_password.prop("type", "text")
                      }
                      if (el_eyes[0].style.display == "none") {
                        el_eyes[0].style.display = "inherit"
                        el_eyes[1].style.display = "none"
                      } else {
                        el_eyes[0].style.display = "none"
                        el_eyes[1].style.display = "inherit"
                      }
                      return false;
                    }} />
                </ListItem>
              </List>
              <List>
                <ListButton title="ログイン" onClick={(e) => {
                  if (!haccpUtils.validateForm($$(e.target).closest("form"), e.target)) return false;
                  alertLoginData('パスワードをリセットしますか？', 'ログインに失敗しました')
                }} />
                <ListButton title="新規登録" onClick={openCreateUserDialog} popupOpen="#haccp-popup" />
              </List>
              <List>
                <ListButton title="パスワードを忘れた方はこちら" onClick={(e) => {
                  // if($$("[name='username']").val() == "") {

                  // }
                  // $$("[name='password']").val("")
                  $$("[name='password']").val("************")
                  if (!haccpUtils.validateForm($$(e.target).closest("form"), e.target)) return false;
                  alertLoginData('パスワード リセットしますか?', 'パスワード変更')
                }} />
                <p style={{ color: "red", fontSize: "12px", textAlign: "center", marginTop: "0px", marginBottom: "0px" }}>
                  ※パスワードを忘れた方は、
                </p>
                <p style={{ color: "red", fontSize: "12px", textAlign: "center", marginTop: "0px" }}>
                  メールアドレスを入力してからお進み下さい
                </p>
              </List>
              <List>
                <ListButton title="戻る" onClick={()=>{
                  // f7.panel.close(".panel-right"); // 右パネルを閉じる
                  f7.panel.close(".panel-left"); // 左パネルを閉じる
                  f7.loginScreen.close();
                }} />
              </List>
            </form>
          </Page>
        </View>
      </LoginScreen>


      <Popup id="haccp-popup"
        onPopupClosed={() => {
          const form = $$("#haccp-popup form")
          if (form && form.length > 0) ReactDOM.render(<Block />, form[0])
        }}
      ></Popup>
    </App>
  )
}
export default MyApp;
